import React from 'react';

import { MicrosoftValue } from './types';

const MicrosoftContext = React.createContext<MicrosoftValue>({
  azureIdentity: null,
  planData: null,
  purchaseToken: null,
  subscriberTenantId: null,
  fetchPlanData: null,
  resetPlanData: null,
  setPurchaseToken: null,
  setSubscriberTenantId: null,
  handleSSO: null,
  isAuthenticated: false,
  isPublisher: false,
  setAzureIdentity: null,
  setBearerToken: null,
  setIsAuthenticated: null,
  setIsPublisher: null,
  error: null,
  bearerToken: null,
  graphData: null,
});

export default MicrosoftContext;
